import { render, staticRenderFns } from "./FileUploadItem.vue?vue&type=template&id=2f548ba5&scoped=true&"
import script from "./FileUploadItem.vue?vue&type=script&lang=js&"
export * from "./FileUploadItem.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadItem.vue?vue&type=style&index=0&id=2f548ba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f548ba5",
  null
  
)

export default component.exports